/**
 * @description bank account Micro Deposit status
 */
export enum BankAccountMicroDepositStatus
{
  Posted = 'Posted'
}



// WEBPACK FOOTER //
// ./src/model/types/bank-account-micro-deposits-status.ts